module.exports = __webpack_public_path__ + "media/images/chevron_arrow-6b1f12fcaa0f0e8c0ad38407b2742964.svg";